import React, { ReactNode } from "react";

type Props = {
    title: string;
    count?: number | string;
    meta?: string;
    right?: ReactNode;
};

export const SectionHeader: React.FC<Props> = ({ title, count, meta, right }) => (
    <div className="section__hd">
        <div className="section__title">
            {title}
            {count !== undefined ? <span className="count">{count}</span> : null}
        </div>
        <div className="section__meta">
            {meta !== undefined && meta !== "" ? <span>{meta}</span> : null}
            {right}
        </div>
    </div>
);
